// Value is in hours
export const ACTIVITY_TIME_DIFFERENCE_ALERT = 8;
